import React, { Component } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { Empty, Alert, Skeleton, Modal, Button } from 'antd';


import "react-datepicker/dist/react-datepicker.css";

import 'bootstrap/dist/css/bootstrap.min.css';

import { connect } from 'react-redux'
import * as subscriptions from './Store/subscriptions'
import * as com from "./Common"
import PlanModal from "./planModal";
import { checkAccess, checkAloneAccess } from "./Auth";
import { UR_LoanProcessor, UR_Owner } from "./State";
import { Link } from 'react-router-dom'
import { WarningWithFeedback } from './Common/components/Warning'
import { downloadFileStream } from './Common/common.js';
const mapStateToProps = (state) => {
    return {
        application: state.application,
        progress: state.progress,
        borrower: state.borrower,
        subscriptionReducer: state.subscriptionReducer.currentInfo,
        planUsage: state.subscriptionReducer.currentInfo.usage,
    }
}

const mapDispatchToProps = (dispatch) => ({
    updateMISMOUsage: (usage) => dispatch(subscriptions.updateMISMOUsage(usage)),
    updateForm1003Usage: (usage) => dispatch(subscriptions.updateForm1003Usage(usage)),
});

class FormPreview extends Component {

    constructor(props) {
        super(props);
        this.state = {
            monthlyUsage: 0,
            preview: [],
            renderer: <Skeleton active/>,
            isModalOpen: false,
        }
        this.prefix = "data:image/png;base64,"
        this.downloadref = React.createRef()
    }

    componentDidMount() {
        this.reload()
    }

    download = () => {
        console.log('this.props.planUsage',this.props.planUsage)
        const status = com.getStatus(com.getLoId(), this.props.subscriptionReducer.loanOfficers)
        if (status !== undefined) {
            if (status === 'free' && !checkAloneAccess([UR_LoanProcessor])) {
                // 检查总免费次数限制（mismoUsage + form1003Usage >= 10）
                if ((this.props.planUsage?.mismoUsage + this.props.planUsage?.form1003Usage) >= 10) {
                    this.setState({ isModalOpen: true })
                    return
                }
                // 检查月度使用次数限制
                if (this.state.monthlyUsage >= 3) {
                    this.setState({ isModalOpen: true })
                    return
                }
            }
        }
        this.downloadref.current.click()
        // 根据表单类型调用相应的记录方法
        if (this.props.form === '1003') {
            this.recordForm1003Usage()
        } else {
            this.recordmismousage()
        }
    }

    recordmismousage = () => {
        let token = sessionStorage.getItem("ZeitroA")
        fetch(`/los/recordmismousage/${this.props.borrower.loan_id}`, {
            method: 'GET',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            }
        }).then(response => {
            if (response.status !== 200) {
                console.log(response)
                return;
            }
            response.json().then(js => {
                if (js.Status === "OK") {
                    this.props.updateMISMOUsage(js.Count)
                }
            })
        })
    }

    recordForm1003Usage = () => {
        let token = sessionStorage.getItem("ZeitroA")
        fetch(`/los/recordform1003usage/${this.props.borrower.loan_id}`, {
            method: 'GET',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            }
        }).then(response => {
            if (response.status !== 200) {
                console.log(response)
                return;
            }
            response.json().then(js => {  
                if (js.Status === "OK") {
                    this.props.updateForm1003Usage(js.Count)
                }
            })
        })
    }

    // download mismo file
    downloadMismo = async () => {
        let token = sessionStorage.getItem("ZeitroA");
        const { loanOfficers } = this.props.subscriptionReducer;
        const errDom = <div className="p-5">
            <WarningWithFeedback
                title="System error"
                message="Our system encountered an unexpected error while generating the MISMO file. Please try again later or report this issue to our support team."
                product="Loans"
                feature="MISMO"
                type="issue" />
        </div>
        try {
            const status = com.getStatus(com.getLoId(), loanOfficers)
            // 使用次数超过10次，则弹出提示
            if (status && status === 'free' && !checkAloneAccess([UR_LoanProcessor]) && (this.props.planUsage?.mismoUsage + this.props.planUsage?.form1003Usage) >= 10) {
                this.setState({ isModalOpen: true })
                return
            }
            const response = await fetch(`/los/getmismothreefour/${this.props.borrower.loan_id}`, {
                method: 'GET',
                headers: {
                    Authorization: "Bearer " + token,
                    Cache: "no-cache"
                }
            })
            if (response.status !== 200) {
                this.setState({
                    renderer: errDom
                })
                return;
            }
            const contentType = response.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                // 错误，读取 json 展示后端返回的错误信息
                const errJson = await response.json();
                // let obj = JSON.parse(atob(json.Document))
                // if (obj.Error && obj.Error === "Data.Text.Internal.Fusion.Common.index: Index too large") {
                //     obj.Error = "Borrower credit information (SSN) is required to proceed. Please enter this information in the 1003 section to generate the MISMO file."
                // } else if (obj.Error && obj.Error.includes("invalid address line")) {
                //     obj.Error = "Missing property address: Please provide the complete property address in the 1003 section to generate the MISMO file."
                // } else if (obj.Error && obj.Error.includes("unrecognized purpose type")) {
                //     obj.Error = "Missing loan purpose: Please select a valid purpose type in the 1003 section to generate the MISMO file."
                // } else {
                //     obj.Error = "Our system encountered an unexpected error while generating the MISMO file. Please try again later or report this issue to our support team."
                // }
                this.setState({
                    renderer:
                        (
                            <div className="m-5"><Empty className="mb-4" description={
                                <div>
                                    Document is not available yet
                                </div>
                            } />
                                <WarningWithFeedback title="MISMO file generation error" product="Loans" feature="MISMO" type="issue" message={errJson.errMessage} />
                            </div>
                        )
                })
                return;
            }
            // 正确，下载文件
            await downloadFileStream(response, this.recordmismousage);
        } catch (error) {
            this.setState({
                renderer: errDom
            })
        }
    }


    reload = () => {
        let token = sessionStorage.getItem("ZeitroA")
        let { id } = this.props.borrower

        let url
        let headers = {
            Authorization: "Bearer " + token,
            Cache: "no-cache",
            'X-Loan': this.props.borrower.loan_id
        }
        if (this.props.form === '1003') {
            url = `/los/get${this.props.form}/b64/${id}`
        } else if (this.props.form === 'undefined') {
            this.setState({
                renderer:
                    (<div>
                        <p style={{fontSize: '25px'}}>This information is not available yet.</p>
                    </div>)
            })
            return
        } else if (this.props.form === 'mismo34') {
            this.setState({
                renderer:
                    // ( current < loansubmitted ? 
                    //         <div className='forms-preview text-center'>
                    //             <h4 className="mt-3 mb-5">Customer application is not submitted yet</h4>
                    //             <div style={{width: '80%', marginLeft: 'auto', marginRight: 'auto'}}>
                    //                 The interview must reach the last page, and application must be submitted. Even if the borrower or yourself went back, and made an edit, one has to step through all pages to the end to ensure consistency of the application.
                    //             </div>
                    //         </div>
                    //         :
                    <div className='forms-preview'>
                        <h4 className="mt-3 mb-5">Please click below to download FNM 3.4 file</h4>
                        <div onClick={this.downloadMismo} className='documentDownload'><i style={{ fontSize: '70px', top: '15px', left: '47%' }} className="fas fa-file-download"></i></div>
                    </div>
                // )
            })
            return;
        } else {
            url = `/los/getform/b64/${id}`
            headers['X-form'] = this.props.form
        }

        fetch(url, {
            method: 'GET',
            headers
        }).then(
            response => {
                if (response.status !== 200) {
                    console.log('Looks like there was a problem. Status Code: ' +
                        response.status);
                    return;
                }
                response.json().then(json => {
                    let doc = json.Document
                    if (this.props.borrower.id !== id) {
                        this.reload()
                    } else {
                        this.setState({ preview: doc.pngPagesBase64 })
                        this.setState({
                            renderer:
                                (
                                    <div className='forms-preview'>
                                        <a ref={this.downloadref} hidden href={`data:application/pdf;base64,${doc.documentBase64}`} download={this.props.borrower.fullname + " " + this.props.form}> </a>
                                        <div onClick={this.download} className='forms-download documentDownload'><i style={{ fontSize: '40px' }} className="fas fa-file-download"></i></div>
                                        {this.state.preview.map((page, index) =>
                                            <img key={index} alt="view" src={this.prefix + page} />
                                        )}
                                    </div>
                                )
                        })
                    }

                });
            }
        )
            .catch(function (err) {
                console.log('Fetch Error :-S', err);
            });
    }

    render() {

        return (
            <div className="text-center mt-3 bluish">
                {this.state.renderer}
                <PlanModal isModalOpen={this.state.isModalOpen} closeModal={() => {
                    this.setState({ isModalOpen: false })
                }} isMismo={true} />


            </div>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(FormPreview)
